module.exports = __webpack_public_path__ + "img/84.4.NH3-N.5f2f3bb1.png";